<template>
  <div class="header-container">
    <div class="logo-container">
        <img @click="onClickButton()" class="logo" src="~@/assets/imgs/logo.svg" />
    </div>
    <div v-if="currentPage == 2" class="text-container">
      <h2>SO SIEHT'S AUS!</h2>
      <p>Das ist dein Design. Alles schick?
Oder willst du noch was ändern?
Klick einfach den entsprechenden Button.</p>
    </div>
    <div v-else-if="currentPage == 3 || currentPage == 4" class="text-container">
      <h2>Alles klar, dann sehen wir uns gleich!</h2>
          <p>Fast fertig. Verrate uns nur noch, für wen das Feuerzeug
    ist und dann komm zu unserem Stand und hol dir
    Dein Designerstück ab!
    </p>
    </div>
    <div v-else class="text-container">
      <h2>DESIGN DRAUF LOS!</h2>
      <p>Auf geht’s: Wähle die Icons und den Text aus, die du für
dein Design verwenden möchtest. Danach kannst Du die
Größe skalieren und die Position auf deiner Hülle festlegen.
Tob dich aus!</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Head",
  props: ['currentPage'],
  methods: {
    onClickButton () {
      this.$emit('start')
    }
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  min-height: 185px;

  .logo-container {
    height: 100px;
    padding-right: 42px;
    padding-bottom: 0;
    margin-top: 32px;
    border-right: 2px solid #2351A0;

    img {
      cursor: pointer;
    }
  }
  .text-container {
    padding-top: 32px;
    padding-left: 47px;

    p {
      max-width: 390px;
      font-size: 16px;
      font-weight: normal;
      line-height: 23px;
      color: black;
    }

    h2 {
      font-weight: bold;
      font-size: 18px;
      line-height: 18px;
    }
  }
}

</style>
